
<template>
    <div style="padding: 20px 20px 0 20px;">
        <div style="padding:14px;background: #fff;">
            <div style="display: flex;justify-content: space-between;align-items: center;padding-bottom: 10px;">
                <div class="span_but">
                    <span style="font-weight: 550;cursor: default;">车牌号 : {{vehicleNumber}}</span> 
                    <span style="cursor: default;">数据截止时间：{{ time.slice(0,4)+'年'+time.slice(4)+'月' }}</span>
                </div>
                <div>
                   <el-button class="m-l-2" @click="goBack">返回上级</el-button>
                   <el-button v-show="hideExport" style="margin-left:20px;" @click="exportDate">导出</el-button>
                </div>
            </div>
            <div style="">
                <el-table ref="singleTable" empty-text="暂无相关信息" :header-cell-style="{background:'#eef1f6'}" :data="listData" height="68vh"  stripe  style="width: 100%" >
                    <el-table-column type="index" width="48" label="序号" align="center"></el-table-column>
                    <el-table-column property="cardNumber" label="卡号" width="150"  align="center"></el-table-column>
                    <el-table-column property="provinceName" label="办卡省" width="100" align="center" > </el-table-column>
                    <el-table-column property="cityName" label="地市" width="80"  align="center"></el-table-column>
                    <!-- <el-table-column property="userName" label="客户姓名" width="90" align="center" ></el-table-column> -->
                    <el-table-column property="userType" label="账号类型" width="80" align="center" ></el-table-column>
                    <el-table-column property="cardType" label="卡性质" width="80"  align="center"></el-table-column>
                    <el-table-column property="consumerCode" label="客户编号" width="100" align="center" ></el-table-column>
                    <el-table-column property="companyName" label="单位名称" align="center" >
                        <template slot-scope="scope">
                            {{scope.row.companyName==''?'--':scope.row.companyName}}
                        </template>
                    </el-table-column>
                    <el-table-column property="litter" label="持卡消费量(升)"  align="center">
                        <template slot-scope='scope'>
                            {{format(scope.row.litter)}}
                        </template>
                    </el-table-column>
                    <el-table-column property="getpref" label="优惠金额(元)" align="center" >
                        <template slot-scope='scope'>
                            {{format(scope.row.getpref)}}
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
    </div>
</template>

<script>
import Cookies from 'js-cookie'
import http from '@/api/cardData'
import { hideExport } from '@/utils/tools'
export default {
    data () {
        return {
            hideExport:hideExport,
            listData:[],
            vehicleNumber:'',
            time:''
        }
    },
 
    mounted() {
        this.getListData();
        this.time = this.$route.query.time;
    },
    methods: {
        getListData(){
            http[0].cardDetailList({
                carNumber: this.$route.query.carNum
            }).then(e=>{
                this.listData = e.data||[];
                this.vehicleNumber = e.data[0]&&e.data[0].vehicleNumber||'';
            })
        },
        goBack() {
            sessionStorage.setItem('isAlive',1)
            this.$router.go(-1)
        },
        exportDate(){
            window.location.assign(`/bi-api/vehicleCardCount/cardDetailListExport?carNumber=${this.$route.query.carNum}`)
        },
        format(num) {
            var res=num.toString().replace(/\d+/, function(n){ // 先提取整数部分
                return n.replace(/(\d)(?=(\d{3})+$)/g,function($1){
                    return $1+",";
                });
            })
            return res;
        },
    }
}
</script>

<style scoped>
.span_but span{
    margin-right: 30px;
    font-size: 14px;
    display: block;
    margin-bottom: 10px;
}
.span_current{
       color: #4e8ed6;
}
</style>